import React, { FunctionComponent } from 'react';
import { ANAMNESIS_SEVERITY_COLORS } from 'components/patient-entry/bookings-table/InterventionBookingsTableView';
import { Icon } from 'semantic-ui-react';
import { AnamnesisSeverity } from 'ts-types/api.types';
import { MessageSourceProps, withMessages } from 'react-message-source';
import styled from 'styled-components';

interface IconProps {
  severity: AnamnesisSeverity | string;
  className?: string;
  title?: string
}

const SeverityTagDiv = styled.div`
  .severity-icon {
    padding-right: 0.25rem;
  }
`;

export const AnamnesisSeverityIcon: FunctionComponent<IconProps> = (
    { severity, className, title }) => {

  if (severity === undefined || severity === null || severity === "") {
    return <></>;
  }

  if (severity === "any") {
    return <Icon name="circle outline" className={`severity-icon ${className}`} fitted title={title} color="grey" />
  }

  const color = ANAMNESIS_SEVERITY_COLORS[severity];
  return <Icon name="circle" className={`severity-icon ${className}`} fitted title={title} color={color} />
};


interface TagProps extends IconProps, MessageSourceProps {
}

const AnamnesisSeverityTagUI: FunctionComponent<TagProps> = (props) => {

  const {severity, className, getMessage} = props;
  const text = severity ? getMessage(`enum.AnamnesisSeverity.${severity}`) : "";
  return <SeverityTagDiv className={className}>
    <AnamnesisSeverityIcon severity={props.severity} title={props.title} />
    {text}
  </SeverityTagDiv>;
};

export const AnamnesisSeverityTag = withMessages(AnamnesisSeverityTagUI);
